/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import {h, Component} from 'preact';
import {withSideEffect as withSideEffect_} from './SideEffect.js';

export function withSideEffect/*:: <Props, State> */(
  reducePropsToState /*: (props: Props[]) => State */,
  handleStateChangeOnClient /*: (props: State) => void */
) /*: (
  WrappedComponent: React$ComponentType<Props>
) => React$Component<Props, State> */ {
  return withSideEffect_(
    // $FlowIssue
    h,
    Component,
    reducePropsToState,
    handleStateChangeOnClient
  );
}
